import * as React from 'react';
import {isLastPageInRange} from '../../../../utils/pagination';
import DirectToLastPageLink from '../DirectToLastPageLink';
import GoToFirstPageLink from '../GoToFirstPageLink';
import GoToPreviousPageLink from '../GoToPreviousPageLink';
import GoToNextPageLink from '../GoToNextPageLink';
import GoToLastPageLink from '../GoToLastPageLink';
import {Link} from 'react-router-dom';
import s from './desktop.scss';
import {withTranslation} from 'react-i18next';
type DesktopProps = {
  t: (...args: any[]) => any,
  data: any,
  makePagePath: (...args: any[]) => any
};
class Desktop extends React.Component<DesktopProps, {}> {
  render() {
    const {data, makePagePath, t} = this.props;
    const {range, first, last, next, previous} = data;
    const lastPageInRange = isLastPageInRange(range, last.index);
    const hideForwardButton = lastPageInRange;
    const hidePreviousButton = range[0].active;
    return (
      <nav data-hooks="pagination-navigation-desktop" className={s.pagination}>
        <GoToFirstPageLink
          active={first.active}
          hide={hidePreviousButton}
          path={makePagePath(first.index)}
          page={first.index}
        />
        <GoToPreviousPageLink
          active={previous.active}
          hide={hidePreviousButton}
          path={makePagePath(previous.index)}
          page={previous.index}
        />
        {range.map(page => (
          <li
            data-hooks="go-to-specific-page"
            key={page.index}
            className={`${s.link}${page.active ? ` ${s.linkActive}` : ''}`}
          >
            <Link data-hooks="go-to-page" to={makePagePath(page.index)}>
              {page.index}
              <span className={s.hidden}>{`${t('navigate-to-page')} ${
                page.index
              }`}</span>
            </Link>
          </li>
        ))}
        {!lastPageInRange ? (
          <li data-hooks="dots" aria-hidden="true">
            ...
          </li>
        ) : (
          ''
        )}
        <DirectToLastPageLink
          active={last.active}
          hide={hideForwardButton}
          path={makePagePath(last.index)}
          page={last.index}
        />
        <GoToNextPageLink
          active={next.active}
          hide={hideForwardButton}
          path={makePagePath(next.index)}
          page={next.index}
        />
        <GoToLastPageLink
          active={last.active}
          hide={hideForwardButton}
          path={makePagePath(last.index)}
          page={last.index}
        />
      </nav>
    );
  }
}
export default withTranslation()(Desktop);
